import React, { FC, ReactElement, cloneElement } from "react";

import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  SvgIconProps,
} from "@mui/material";

import { setOrgClusterOpen } from "../slices/organizations";
import { useDispatch, useSelector } from "../store";
import {
  useGetClusterQuery,
  useListOrganizationsQuery,
} from "../store/pomeriumApi";
import { HostedChip } from "./HostedChip";
import { ClusterIcon, OrganizationIcon } from "./icons";

type BreadcrumbItemProps = {
  icon: ReactElement<SvgIconProps>;
  name: string;
};
const BreadcrumbItem: FC<BreadcrumbItemProps> = ({ icon, name }) => {
  const dispatch = useDispatch();

  const handleClick = () => dispatch(setOrgClusterOpen(true));

  return (
    <Link
      color="inherit"
      sx={{ cursor: "pointer" }}
      onClick={handleClick}
      underline="hover"
    >
      {cloneElement(icon, {
        color: "inherit",
        fontSize: "inherit",
        sx: { mr: 0.5 },
      })}
      {name}
    </Link>
  );
};

type BreadcrumbsProps = Record<string, never>;
const Breadcrumbs: FC<BreadcrumbsProps> = () => {
  const organizationId = useSelector((state) => state.current.organizationId);
  const clusterId = useSelector((state) => state.current.clusterId);

  const { data: organizations } = useListOrganizationsQuery();
  const { data: cluster } = useGetClusterQuery(
    {
      organizationId: organizationId || "",
      clusterId: clusterId || "",
    },
    {
      skip: !organizationId || !clusterId,
    },
  );
  const organization = organizations?.find(
    (organization) => organization.id === organizationId,
  );

  return (
    <MuiBreadcrumbs separator="•">
      {organization && (
        <BreadcrumbItem
          icon={<OrganizationIcon />}
          name={organization.name || ""}
        />
      )}
      {cluster && (
        <div className="flex items-center gap-1">
          <BreadcrumbItem icon={<ClusterIcon />} name={cluster.name || ""} />
          {cluster.flavor === "hosted" ? <HostedChip /> : null}
        </div>
      )}
    </MuiBreadcrumbs>
  );
};
export default Breadcrumbs;
